// ##############################
// // // CustomSelects styles
// #############################

import {
    dangerColor,
    successColor,
    dangerBoxShadow,
    defaultFont
} from "@app/assets/jss/material-kit-pro-react.jsx";

const customSelectStyle = {
    formControl: {
        margin: "0 0 17px 0",
        paddingTop: "27px",
        "& > div": {
            marginTop: "0px",
            "&:before": {
                borderBottomWidth: "1px !important",
                borderBottomColor: "#D2D2D2 !important"
            },
            "&:after": {
                borderBottomColor: dangerColor[1] + "!important"
            }
        }
    },
    selectRoot: {        
    },
    labelRoot: {
        ...defaultFont,
        color: "#000000  !important",
        fontWeight: "400",
        fontSize: "19px",
        lineHeight: "1.42857",
        top: "5px"
    },
    labelRootError: {
        color: dangerColor + " !important"
    },
    labelRootSuccess: {
        color: successColor + " !important"
    },  
    select: {
        marginTop: '2px',
        fontSize: "14px",
        fontWeight: "400",
        lineHeight: "1.42857",
        textDecoration: "none",
        color: "#495057",
        letterSpacing: "0",
        "&:focus": {
            backgroundColor: "transparent"
        },
        "&[aria-owns] + input + svg": {
            transform: "rotate(180deg)"
        },
        "& + input + svg": {
            transition: "all 300ms linear"
        }
    },
    whiteSelect: {
        "&,&::placeholder": {
            color: "#FFFFFF",
            opacity: "1"
        }
    },
    selectMenu: {
        "& > div > ul": {
            border: "0",
            padding: "5px 0",
            margin: "0",
            boxShadow: "none",
            minWidth: "100%",
            borderRadius: "4px",
            boxSizing: "border-box",
            display: "block",
            fontSize: "14px",
            textAlign: "left",
            listStyle: "none",
            backgroundColor: "#fff",
            backgroundClip: "padding-box"
        }
    },
    selectMenuItem: {
        fontSize: "13px",
        padding: "10px 20px",
        margin: "0 5px",
        borderRadius: "2px",
        transition: "all 150ms linear",
        display: "block",
        clear: "both",
        fontWeight: "400",
        lineHeight: "2",
        whiteSpace: "nowrap",
        color: "#495057",
        paddingRight: "30px",
        "&:hover": {
            backgroundColor: dangerColor[1],
            color: "#FFFFFF",
            ...dangerBoxShadow
        }
    },
    selectMenuItemSelected: {
        backgroundColor: dangerColor[1] + "!important",
        color: "#FFFFFF"
    }
};

export default customSelectStyle;
